import events from '../eventNames';
import track from '../track';

/**
 * Send a tracking event for when user clicks to view another press slide
 */
export function trackCondensedPressBarClicked(): void {
  track(events.condensed_press_bar_clicked);
}
